<div class="container">
  <div class="container__title">
    <h2 class="title">{{ title }}</h2>
  </div>
  <div class="container__content"><ng-content></ng-content></div>
</div>
